import React, { useCallback } from 'react';
import ModalComponent from 'components/modal/modalComponent';
import { ModalButtonProps } from 'components/modal/modal.interfaces';
import { useNavigate } from 'react-router-dom';
import InputComponent from 'components/inputComponent';

interface AcceptAiModalProps {
  isOpen: boolean;
  setIsCheckboxChecked: React.Dispatch<React.SetStateAction<boolean>>;
}

const AcceptAiModal: React.FC<AcceptAiModalProps> = ({
  isOpen,
  setIsCheckboxChecked,
}) => {
  const navigate = useNavigate();
  const [localChecked, setLocalChecked] = React.useState(false);

  const handleCheckboxChange = (checked: boolean) => {
    setLocalChecked(checked);
  };

  const handleAccepted = () => {
    setIsCheckboxChecked(true);
  };

  const onClose = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const Buttons: ModalButtonProps[] = [
    {
      label: 'Accept',
      onClick: handleAccepted,
      disabled: !localChecked,
      testID: 'accepted',
      className: '!text-sm !font-bold !rounded !py-2.5 !leading-[20px] w-auto',
    },
  ];

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      buttons={Buttons}
      title="Accept AI-powered transcription"
      modalDesktopWidth="desktop:max-w-[670px]"
    >
      <p className="text-med-gray-3 font-medium">
        This online visit may use AI-powered transcription to assist your
        healthcare provider with documenting the conversation. Any information
        collected during the visit will be handled according to the requirements
        set forth by the HIPAA privacy and security rules. Any information
        collected is used solely for clinical documentation and care purposes.
        AI-generated transcription records are automatically deleted after 30
        days
      </p>
      <div className="flex flex-row gap-2.5 items-start">
        <InputComponent
          testID="policy-input"
          type="checkbox"
          name="agreementsCheckbox"
          checkboxProps={{
            checked: localChecked,
            onCheckboxChange: handleCheckboxChange,
            isAlternativeCheckboxColor: true,
            checkboxLabel: (
              <div className="text-med-gray-3 text-sm font-semibold">
                <p>
                  I acknowledge and consent to the use of AI transcription
                  during this visit
                </p>
              </div>
            ),
          }}
        />
      </div>
    </ModalComponent>
  );
};

export default AcceptAiModal;
